module.exports = __webpack_public_path__ + "static/img/gp.6db03b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/th/gp.png
// module id = kc8y
// module chunks = 1